import { render, staticRenderFns } from "./PrintOptions.vue?vue&type=template&id=ddd8afbc&scoped=true"
import script from "./PrintOptions.vue?vue&type=script&lang=js"
export * from "./PrintOptions.vue?vue&type=script&lang=js"
import style0 from "./PrintOptions.vue?vue&type=style&index=0&id=ddd8afbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd8afbc",
  null
  
)

export default component.exports